export type Notice = {
  severity: "error" | "warning" | "info";
  title?: string;
  message?: string;
};

const RANK = { error: 0, warning: 1, info: 2 } as const;

// The instance's notices, the most severe first; equal ones keep their order.
export const sortedNotices = (
  notices: (Notice | null | undefined | false | "")[]
): Notice[] =>
  notices
    .filter((notice): notice is Notice => Boolean(notice))
    .sort((a, b) => RANK[a.severity] - RANK[b.severity]);
